export enum ImportMigrationType {
  Unknown = 'Unknown',
  Historic = 'Historic',
  All = 'All',
  Recent = 'Recent',
  Current = 'Current',
}
